import { absoluteDateFormatter } from '@seek/unified-display-date-time';
import type React from 'react';

import { useConfig } from 'src/hooks/useConfig';

export interface DateFormatProps {
  date: string;
}

export const DateFormat: React.FC<React.PropsWithChildren<DateFormatProps>> = ({
  date,
}) => {
  const { locale } = useConfig();
  const result = absoluteDateFormatter({
    date: new Date(date),
    format: 'short',
    locale,
  });

  if (result.isValid) {
    return <time dateTime={date}>{result.formattedDate}</time>;
  }

  return null;
};
